import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMujallah } from "./_request";
import { websiteUrl } from "../../const/constants";
import defaultMujallahImage from "../../Assets/images/magzine.png";

const MujallahHighlights = ({ mujallah }) => {
  const [mujallahs, setMujallahs] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (!mujallah) {
      getMujallah()
        .then((res) => {
          if (res.Result && res.Mujjallah?.length > 0) {
            const mujallahFetched = res.Mujjallah.map((item) => item.mujjalah);
            setMujallahs(mujallahFetched);
          }
        })
        .catch((err) => console.error("Error fetching Mujallahs:", err));
    } else {
      setMujallahs([mujallah]);
    }
  }, [mujallah]);

  const getHijriYearRange = (gYear) => {
    if (!gYear) return "۱۴۴۵-۱۴۴۶";
    const hYear =
      parseInt(gYear) - 622 + Math.floor((parseInt(gYear) - 622) / 32);
    const urduDigits = (str) =>
      str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
    return `${urduDigits(hYear)} - ${urduDigits(hYear + 1)}`;
  };

  const getImageUrl = (path) => {
    if (!path) return defaultMujallahImage;
    return path.startsWith("http")
      ? path
      : `${websiteUrl}/mujjalahImages/${path.replace(/^\//, "")}`;
  };

  const handleSeeMore = () => navigate("/tableeghat/mujallah");

  if (!mujallahs.length) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
      </div>
    );
  }

  const latest = mujallahs[0]; // display only the first one for now

  return (
    <div className="py-8 sm:py-10 md:py-12 px-5 sm:px-10 md:px-20 rounded-3xl">
      <button
        onClick={handleSeeMore}
        className="flex flex-col-reverse lg:flex-row-reverse items-center justify-between gap-6 w-full"
      >
        {/* Text Content */}
        <div className="w-full lg:w-1/2 text-right flex flex-col items-end">
          <p className="font-nastaleeqKasheeda text-2xl sm:text-3xl md:text-4xl lg:text-4xl mb-4 max-w-[470px] mx-auto lg:mx-0">
            {getHijriYearRange(latest?.year)}
            &#8202;&#8202;&#8202;&#8202;&#8202;&#8202;مجلہ
          </p>
          <p className="tracking-[0.1rem] text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqRegular max-w-[470px] mx-auto lg:mx-0">
            ایسوسی آف مشتاقانِ نور (عج) ہر سال تعارف امام زمانہ علیہ السلام کے
            عنوان سے مجلہ کا اجرا کرتی ہے۔ الحمد للہ یہ کام گزشتہ کئی سالوں سے
            برادران کے علمی مطالعہ اور کوششوں سے جاری ہے
          </p>
        </div>

        {/* Image */}
        <div className="w-full lg:w-1/2 flex justify-center lg:justify-start">
          <img
            src={getImageUrl(latest?.image)}
            alt={`Mujallah ${latest?.year || "۲۰۲۵"}`}
            className="max-h-72 object-contain rounded-lg shadow-lg"
            onError={(e) => {
              e.target.src = defaultMujallahImage;
            }}
            loading="lazy"
          />
        </div>
      </button>
    </div>
  );
};

export default MujallahHighlights;
